import {usePrevious} from "../../../misc/helperHooks";
import {useEffect, useState} from "react";
import {LOOK_OVERLAYS} from "../../look/core/constants";

let animationTimeout = null;

export const useAnimationFinishedTeaser = ({fabricatorData, aiLoading, lookOverlayOpened,}) => {
  const prevLookOverlayOpened = usePrevious(lookOverlayOpened);

  const [animationActive, setAnimationActive] = useState(false);
  const [animationShown, setAnimationShown] = useState(false);

  useEffect(() => {
    if (!fabricatorData.aiSettings.enableAI) {
      return
    }
    if (!animationShown && aiLoading && !lookOverlayOpened && (prevLookOverlayOpened === LOOK_OVERLAYS.aiPanel)) {
      clearTimeout(animationTimeout);
      setAnimationActive(true);
      animationTimeout = setTimeout(() => {
        setAnimationShown(true);
        setAnimationActive(false);
      }, 2750)
    }
    return () => {
      clearTimeout(animationTimeout)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fabricatorData, aiLoading, lookOverlayOpened, animationShown]);

  return {animationActive, animationShown}
};
